import React from 'react';
import classNames from 'classnames';
import styles from './button.module.scss';
export const Button = ({ priority, onClick, dataHook, disabled, children, }) => {
    return (React.createElement("button", { className: classNames(styles.root, styles[`priority-${priority}`], disabled && styles.isDisabled), "data-hook": dataHook, onClick: onClick, disabled: disabled }, children));
};
//# sourceMappingURL=button.js.map